/* eslint-disable */
import React from "react";
import themePropTypes from "../theme-prop-types";

const Tooltip = ({ value }) => {
  return (
    <div className='graph-tooltip-web-sdk'>
      <p>{value}</p>
    </div>
  );
};

Tooltip.propTypes = themePropTypes.graph;
export default Tooltip;
